export default __webpack_public_path__ + "static/media/spinner.74acb2d9.gif";